import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageValidation from '@/icons/PackageValidation.svg';

export const ShipmentVerificationCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'shipment_verification_completed'>;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackageValidation />}
      message={
        <BaseActivityText>
          {activity.creator ? (
            <Trans id="activities.shipment_verification_completed.message">
              <strong>{creatorName}</strong> completed the package verification
            </Trans>
          ) : (
            <Trans id={'activities.shipment_verification_completed.message.no-creator'}>
              The package verification was completed
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
